import ProductModel from "../../Models/PorductModel";

export const AddToRecentlyViewed = (
  product: ProductModel,
  branch_id: number
) => {
  const key = `recently_${branch_id}`;
  let viewed = JSON.parse(localStorage.getItem(key) || "[]");

  // Remove if already exists
  viewed = viewed.filter((item: ProductModel) => item.id !== product.id);

  // Add current product at the beginning
  viewed.unshift(product);

  // Keep only the latest 6
  if (viewed.length > 6) {
    viewed = viewed.slice(0, 6);
  }

  // Save it back
  localStorage.setItem(key, JSON.stringify(viewed));
};

export const getRecentlyViewed = (branch_id: number) => {
  const key = `recently_${branch_id}`;
  return JSON.parse(localStorage.getItem(key) || "[]");
};

export const clearRecentlyViewed = (branch_id: number) => {
  const key = `recently_${branch_id}`;
  localStorage.removeItem(key);
};
